import { useEffect } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { useSellerWallets } from '../../hooks/use-seller-wallets';
import { getAllWalletBalances } from '../utilities/api';
import equals from 'react-fast-compare';

const initialBalanceMap = {};

export const useWalletBalancesMap = () => {
  const wallets = useSellerWallets();
  const [loading, setLoading] = useAsyncSafeState(false);
  const [balancesMap, setBalancesMap] = useAsyncSafeState(initialBalanceMap);

  useEffect(() => {
    if (!wallets?.length) {
      return;
    }
    setLoading(true);
    const load = async () => {
      try {
        const balancesData = await getAllWalletBalances();
        const proposedBalancesMap = balancesData.reduce(
          (acc, balance) => ({
            ...acc,
            [balance.walletId]: balance,
          }),
          {},
        );
        setBalancesMap((previousBalancesMap) => {
          return equals(previousBalancesMap, proposedBalancesMap) ? previousBalancesMap : proposedBalancesMap;
        });
      } catch {
        setBalancesMap(initialBalanceMap);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [
    wallets?.length, // though unused directly, wallets are in the dependency array so we get a fresh list if a new wallet is added
    setLoading,
    setBalancesMap,
  ]);

  return {
    loading,
    balancesMap,
  };
};
